import { BaseEdge } from "@xyflow/react";
import styled from "styled-components";

export const StyledDashedEdge = styled(BaseEdge)`
  stroke-dasharray: 4 3;
  animation: dashdraw 0.5s linear infinite;
  stroke-width: 1;
  stroke: ${({ theme }) => theme.palette.text.primary};
`;

export const StyledEdgeArrowSvg = styled.svg`
  position: absolute;
  width: 0;
  height: 0;

  marker {
    fill: ${({ theme }) => theme.palette.primary.main};
  }
`;
